// extracted by mini-css-extract-plugin
export default {"wrapper":"UserInfoCard_wrapper__LWohh"};